"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummariesApi = void 0;
const node_fetch_1 = __importDefault(require("node-fetch"));
const mfe_common_types_and_mocks_site_search_service_1 = require("@awaze/mfe-common.types-and-mocks.site-search-service");
const ApiClient_1 = __importDefault(require("./ApiClient"));
const errors_1 = require("./errors");
class SummariesApi extends ApiClient_1.default {
    constructor(apiKey, apiUrl) {
        super();
        this.apiKey = apiKey;
        this.apiUrl = apiUrl;
    }
    static throwIfUnsuccessfulResponse(response, results) {
        if (response.ok) {
            return;
        }
        if (response.status >= 400 &&
            response.status < 500 &&
            'message' in results) {
            ApiClient_1.default.throwBadRequestError('/api/summaries', results.message, 'Summaries Bad Request Error', response.status);
        }
        else if (response.status >= 500 &&
            response.status < 600 &&
            'message' in results) {
            throw new errors_1.InternalError(results.message, response.status);
        }
        else if ('message' in results) {
            throw new errors_1.ApiGatewayError(results.message, response.status);
        }
    }
    async getSummariesResponse({ codes, elements, }) {
        if (!codes?.length) {
            return { summaries: [] };
        }
        const params = new URLSearchParams({
            codes: codes.join(','),
            elements: elements.join(','),
        });
        const response = await (0, node_fetch_1.default)(`${this.apiUrl}/summaries?${params.toString()}`, {
            headers: {
                'x-api-key': this.apiKey,
            },
            timeout: mfe_common_types_and_mocks_site_search_service_1.SUMMARIES_API_TIMEOUT,
        });
        const results = await response.json();
        SummariesApi.throwIfUnsuccessfulResponse(response, results);
        return results;
    }
}
exports.SummariesApi = SummariesApi;
//# sourceMappingURL=summaries-api.js.map